import React from "react";
import { motion } from "framer-motion";

const Skills = () => {
  const skillCategories = [
    {
      title: "Frontend",
      icon: "fas fa-laptop-code",
      skills: [
        { name: "JavaScript", icon: "fab fa-js-square" },
        { name: "React.js", icon: "fab fa-react" },
        { name: "Vue.js", icon: "fab fa-vuejs" },
        { name: "HTML/CSS", icon: "fab fa-html5" },
      ],
    },
    {
      title: "Backend",
      icon: "fas fa-server",
      skills: [
        { name: "Node.js", icon: "fab fa-node-js" },
        { name: "Go", icon: "fas fa-code" },
        { name: "PHP", icon: "fab fa-php" },
        { name: "Laravel", icon: "fab fa-laravel" },
      ],
    },
    {
      title: "Database & Cloud",
      icon: "fas fa-database",
      skills: [
        { name: "PostgreSQL", icon: "fas fa-database" },
        { name: "MongoDB", icon: "fas fa-leaf" },
        { name: "Redis", icon: "fas fa-memory" },
        { name: "AWS Lambda", icon: "fab fa-aws" },
      ],
    },
    {
      title: "AI & ML",
      icon: "fas fa-robot",
      skills: [
        { name: "LangChain", icon: "fas fa-brain" },
        { name: "LangSmith", icon: "fas fa-cogs" },
        { name: "LlamaIndex", icon: "fas fa-search" },
        { name: "LlamaParse", icon: "fas fa-file-alt" },
      ],
    },
    {
      title: "Tools & Others",
      icon: "fas fa-tools",
      skills: [
        { name: "Docker", icon: "fab fa-docker" },
        { name: "GraphQL", icon: "fas fa-project-diagram" },
        { name: "CI/CD", icon: "fas fa-sync-alt" },
        { name: "Git", icon: "fab fa-git-alt" },
      ],
    },
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Technical Skills
        </motion.h2>

        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <motion.div
              key={index}
              className="skill-category"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <h3>
                <i className={category.icon}></i> {category.title}
              </h3>
              <div className="skill-items">
                {category.skills.map((skill, skillIndex) => (
                  <motion.div
                    key={skillIndex}
                    className="skill-item"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                  >
                    <i className={`${skill.icon} skill-icon`}></i>
                    <span className="skill-name">{skill.name}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
